export const apiRequestBase =
  (performRequest) =>
  async (requestConfig, registerCancel = () => {}) => {
    const controller = new AbortController();
    registerCancel(() => controller.abort());

    try {
      const response = await performRequest({
        ...requestConfig,
        signal: controller.signal,
      });
      return response;
    } catch (err) {
      if (err?.constructor?.name === 'AbortError') {
        return Promise.reject(err);
      }
      throw err;
    }
  };

const setBaseUrl = (config) => {
  if (window.location?.hostname === 'localhost') {
    // use staging for local development
    return {
      ...config,
      baseURL: `https://api.staging.theconspiracytest.org`,
    };
  }
  return {
    ...config,
    baseURL: `https://api.${window.location.host}`,
  };
};

export const getTctRequestConfig = (initialConfig = {}) =>
  setBaseUrl(initialConfig);

const replaceBaseURLForDataUrls = (config) => {
  if (config.url.indexOf('/data') === 0) {
    return {
      ...config,
      baseURL: window.location.origin,
    };
  }
  return config;
};

export const addInterceptors = (instance) => {
  instance.interceptors.request.use(replaceBaseURLForDataUrls);
};
